module.exports = __webpack_public_path__ + "static/media/imagem6.0f451990.jpeg";